import { useContext } from 'react';
import { Link } from 'react-router-dom';

import classes from './MainNavigation.module.css';
import FavoritesContext from '../../store/favorites-context';

function MainNavigation() {
  const favoritesCtx = useContext(FavoritesContext);

  return (
    <header className={classes.header}>
          <div className={classes.logo}>
              <Link to='/' className={classes.logo}>Conferences</Link>
          </div>
      <nav>
        <ul>
          <li>
            <Link to='/all-meetsup'>All Conferences</Link>
          </li>
          <li>
            <Link to='/new-meetup'>Add New Conference</Link>
          </li>
          <li>
            <Link to='/favorites'>
              My Favorites
              <span className={classes.badge}>
                {favoritesCtx.totalFavorites}
              </span>
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default MainNavigation;
